import {
  buildEventSourceBlock,
  buildPageContextBlock,
  mergeAmplitudeBlocks,
} from '~/analytics/blocks'
import type { AnalyticsLot, SourceBlockType } from '~/analytics/blocks/types'
import type { AmplitudePayloadResult, AnalyticsStore, GAEventOptions, ProductStatus } from '~/analytics/composables-types'
import { buildViewProductGAOptions } from '~/analytics/gaHelpers'
import { appendLotProductOwnerFields } from '~/composables/useLotProductAnalytics'

interface ViewProductPageAmplitudeParams {
  store: AnalyticsStore
  lot: AnalyticsLot
  sourcePageName?: string
  sourcePageType?: string
  sourceBlockType?: SourceBlockType | string
  productList?: string | number
}

interface ViewProductPageGAParams {
  store: AnalyticsStore
  lot: AnalyticsLot
  productList?: string | number
}

export function getLotProductStatus (lot?: AnalyticsLot | null): ProductStatus {
  if (!lot?.hidden && !lot?.deleted) {
    return 'AVAILABLE'
  }
  if (lot?.hidden && !lot?.deleted) {
    return 'HIDDEN'
  }
  return 'DELETED'
}

export function getViewProductPageAmplitudePayload ({
  store,
  lot,
  sourcePageName = '',
  sourcePageType = '',
  sourceBlockType = '',
  productList = '',
}: ViewProductPageAmplitudeParams): AmplitudePayloadResult {
  const payload = mergeAmplitudeBlocks(
    buildPageContextBlock({
      pageName: lot.name,
      pageType: 'PRODUCT',
    }),
    buildEventSourceBlock({
      sourcePageName,
      sourcePageType,
      sourceBlockType,
    }),
    { 'product status': getLotProductStatus(lot) },
  )

  appendLotProductOwnerFields(payload, {
    rootGetters: store.getters,
    lot,
    owner: lot.user,
    productList: productList || '',
  })

  return payload
}

export function getViewProductPageGAOptions ({
  store,
  lot,
  productList = '',
}: ViewProductPageGAParams): GAEventOptions {
  return buildViewProductGAOptions({ store, lot, productList })
}
